export default __webpack_public_path__ + "static/media/CommunicationUnsent.d9323c02.svg";